<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="1"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="2" defaultSel="2"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">
                <div class="nav_search">
                    <div>
                        <el-button type="primary" @click="dialog = true">添加帐号</el-button>
                    </div>
                </div>
                <el-table :data="listData" style="width: 100%">
                    <el-table-column prop="no" label="管理员工号"></el-table-column>
                    <el-table-column prop="nickName" label="姓名"></el-table-column>
                    <el-table-column prop="userName" label="登录帐号"></el-table-column>
                    <el-table-column prop="role" label="权限"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="delectQx(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </el-col>
        </el-row>

        <el-dialog title="添加/修改管理员帐号" :visible.sync="dialog" width="30%">
            <el-select class="order_input1" v-model="roleId" placeholder="管理员权限">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <div class="order_input1">
                <el-input v-model="userName" clearable placeholder="帐号"></el-input>
            </div>
            <div class="order_input1">
                <el-input v-model="uNo" clearable placeholder="工号"></el-input>
            </div>
            <div class="order_input2">
                <el-input v-model="nickName" clearable placeholder="姓名"></el-input>
            </div>
            <p class="order_tip">注：管理员帐号初始密码为：000000</p>
            <span slot="footer" class="dialog_footer">
                <el-button type="primary" @click="sendApi">确定</el-button>
                <el-button @click="dialog = false">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
var util = require("@/common/util.js");
import { API_GLYLIEB, API_GLYXINZ, API_GLYSANC } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            listData: '',
            dialog: false,

            userName: '',
            uNo: '',
            nickName: '',

            roleId: '',
            options: [{
                value: 7,
                label: '业务代理'
            }, {
                value: 4,
                label: '内容管理'
            }, {
                value: 5,
                label: '熟客优选'
            }]
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        getListData() {
            let params = {}
            util.getData(API_GLYLIEB, params, (res) => {
                this.listData = res.data.data
            })
        },
        delectQx(e) { // 删除权限
            this.$confirm('确定删除帐号？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.closeApi(e.userRoleId)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })
        },
        closeApi(id) {
            let params = new URLSearchParams();
            params.append('userRoleId', id);
            util.getData(API_GLYSANC, params, (res) => {
                if(res.data.msg == '该信息不存在'){
                    this.$message('该信息不存在')
                    this.dialog = false
                    return
                }
                this.dialog = false
                this.$message('操作成功')
                this.getListData()
            })
        },
        sendApi() {  // 添加权限
            // console.log(this.roleId)
            // console.log(this.userName)
            // console.log(this.uNo)
            // console.log(this.nickName)
            // return

            if(this.roleId == '' || this.userName == '' || this.uNo == '' || this.nickName == ''){
                this.$message('请完善信息！')
                return
            }
            let params = new URLSearchParams();
            params.append('roleId', this.roleId);
            params.append('userName', this.userName);
            params.append('uNo', this.uNo);
            params.append('nickName', this.nickName);
            util.getData(API_GLYXINZ, params, (res) => {
                this.dialog = false
                this.$message('添加成功')
                this.getListData()
            })
        }
    }
}
</script>
  
<style lang="less">
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}
.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

.nav_search {
    margin-top: 10px;
    margin-bottom: 30px;
}

.order_input1 {
    width: 100%;
    margin-bottom: 20px;
}
.order_tip{
    padding: 20px 0 0;
    color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/glyMg/index.vue